<div id="step-welcome" class="flex min-h-full flex-1 flex-col">
  <div class="flex justify-center mt-fdk-m">
    <fdk-illustration name="location" [style.width.px]="72 * 118 / 104" />
  </div>
  <div class="text-center mt-fdk-xs">
    <h2 class="fdk-type-heading-2 text-fdk-primary">
      Connecting you with Fasten
    </h2>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
      {{
        (configService.systemConfigSubject | async)?.companyName ||
          (configService.systemConfigSubject | async)?.org?.name ||
          "Unknown"
      }}
      uses Fasten to bring your health records together in one place
    </p>
  </div>

  <div class="mt-fdk-l">
    <div class="flex items-top gap-fdk-xs">
      <fdk-icon name="checkmark" [size]="24" class="text-fdk-accent"/>
      <div>
        <h3 class="fdk-type-heading-4 text-fdk-primary">Safe</h3>
        <p class="fdk-type-paragraph text-fdk-secondary">
          Connect your health records with bank-level encryption.
        </p>
      </div>
    </div>
    <div class="mt-fdk-m">
      <div class="flex items-top gap-fdk-xs">
        <fdk-icon name="checkmark" [size]="24" class="text-fdk-accent"/>
        <div>
          <h3 class="fdk-type-heading-4 text-fdk-primary">Private</h3>
          <p class="fdk-type-paragraph text-fdk-secondary">
            We never sell your data. It's only shared with
            {{ (configService.systemConfigSubject | async)?.companyName || (configService.systemConfigSubject | async)?.org?.name || "Unknown" }}.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-auto pt-6">
    <div
      *ngIf="errorMsg"
      class="rounded-md border border-red-200 bg-red-50 p-4"
    >
      <p class="text-sm font-medium text-red-800">We couldn't continue.</p>
      <p class="mt-1 text-sm text-red-700">{{ errorMsg }}</p>
    </div>

    <p
      *ngIf="
        !(needStorageAccessPermissionSubject | async);
        else storagePermissionRequired
      "
      class="fdk-type-paragraph-s text-fdk-secondary mb-fdk-xs"
    >
      By clicking continue you agree to: Fasten's
      <fdk-link
        href="https://policy.fastenhealth.com/connect/privacy_policy.html"
        target="_blank"
        >Privacy Policy</fdk-link
      >
      and
      <fdk-link
        href="https://policy.fastenhealth.com/terms.html"
        target="_blank"
        >Terms & Conditions</fdk-link
      >
      and
      {{
        (configService.systemConfigSubject | async)?.companyName ||
          (configService.systemConfigSubject | async)?.org?.name ||
          "Unknown"
      }}'s
      <fdk-link
        [href]="
          (configService.systemConfigSubject | async)?.org
            ?.privacy_policy_uri ?? ''
        "
        target="_blank"
        >Privacy Policy</fdk-link
      >
    </p>

    <ng-template #storagePermissionRequired>
      <fdk-checkbox
        value="privacy-consent"
        [checked]="storageAccessConsentChecked"
        (change)="onStorageAccessConsentChange($event)"
      >
        <span class="fdk-type-paragraph-s text-fdk-secondary"
          >I've read and agree to Fasten's
          <fdk-link
            href="https://policy.fastenhealth.com/connect/privacy_policy.html"
            target="_blank"
            >Privacy Policy</fdk-link
          >
          and
          <fdk-link
            href="https://policy.fastenhealth.com/terms.html"
            target="_blank"
            >Terms & Conditions</fdk-link
          >
          and
          {{
            (configService.systemConfigSubject | async)?.companyName ||
              (configService.systemConfigSubject | async)?.org?.name ||
              "Unknown"
          }}'s
          <fdk-link
            [href]="
              (configService.systemConfigSubject | async)?.org
                ?.privacy_policy_uri ?? ''
            "
            target="_blank"
            >Privacy Policy</fdk-link
          >.
        </span>
      </fdk-checkbox>
    </ng-template>

    <fdk-button
      type="button"
      variant="primary"
      width="full"
      [disabled]="
        loading ||
        ((needStorageAccessPermissionSubject | async) &&
          !storageAccessConsentChecked)
      "
      (click)="continue()"
    >
      <span class="flex items-center justify-center gap-2"
        ><fdk-spinner *ngIf="loading" /> Continue</span
      >
    </fdk-button>
  </div>
</div>
